import { WorkItem, WorkItemUpdate } from '../api/workItems';

export const ENRICHMENT_LOW_CONFIDENCE_THRESHOLD = 70;

type ConfidenceSource = Pick<WorkItem, 'confidence_score' | 'meta'> | Pick<WorkItemUpdate, 'confidence_score' | 'meta'> | null | undefined;

const readMetaConfidence = (meta: Record<string, any> | null | undefined): number | null => {
    if (!meta) return null;
    const quality = meta.classification_quality;
    const candidate = quality?.confidence_snapshot;
    if (typeof candidate !== 'number' || Number.isNaN(candidate)) {
        return null;
    }
    return candidate;
};

export const getEnrichmentConfidence = (
    item: ConfidenceSource,
    draft?: ConfidenceSource,
): number | null => {
    const draftConfidence = draft?.confidence_score;
    if (typeof draftConfidence === 'number' && Number.isFinite(draftConfidence)) {
        return draftConfidence;
    }

    const itemConfidence = item?.confidence_score;
    if (typeof itemConfidence === 'number' && Number.isFinite(itemConfidence)) {
        return itemConfidence;
    }

    return readMetaConfidence(draft?.meta) ?? readMetaConfidence(item?.meta) ?? null;
};

export const hasPartialEnrichment = (
    item: ConfidenceSource,
    draft?: ConfidenceSource,
): boolean => {
    const meta = draft?.meta ?? item?.meta;
    const partialFields = meta?.classification_quality?.partial_fields;
    return Array.isArray(partialFields) && partialFields.length > 0;
};

export const isLowConfidenceEnrichment = (
    item: ConfidenceSource,
    draft?: ConfidenceSource,
): boolean => {
    const confidence = getEnrichmentConfidence(item, draft);
    if (confidence !== null && confidence < ENRICHMENT_LOW_CONFIDENCE_THRESHOLD) {
        return true;
    }
    const snapshot = readMetaConfidence(draft?.meta) ?? readMetaConfidence(item?.meta);
    return snapshot !== null && snapshot < ENRICHMENT_LOW_CONFIDENCE_THRESHOLD;
};

